import { Alert, Button } from '@mui/material';
import { Coins } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { formatNumber } from '../utils';

interface EstimateSummaryProps {
  estimatedTokens: number;
  advanceTokens: number;
}

/** Estimated advance tokens for the job next to the balance, with a top-up CTA when short. */
export const EstimateSummary: React.FC<EstimateSummaryProps> = ({
  estimatedTokens,
  advanceTokens,
}) => {
  const { t, i18n } = useTranslation();
  const insufficient = estimatedTokens > advanceTokens;

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-center justify-between gap-2 rounded-lg bg-slate-50 px-3 py-2 text-sm dark:bg-slate-800/60">
        <span className="flex items-center gap-2 text-gray-700 dark:text-slate-200">
          <Coins size={16} className="text-blue-500" />
          {t('services.generateVideo.estimate', {
            value: formatNumber(estimatedTokens, i18n.language),
          })}
        </span>
        <span className="text-gray-500 dark:text-slate-400">
          {t('services.generateVideo.balance', {
            value: formatNumber(advanceTokens, i18n.language),
          })}
        </span>
      </div>
      {insufficient && (
        <Alert
          severity="warning"
          action={
            <Button component={Link} to="/subscription" color="inherit" size="small">
              {t('services.generateVideo.buyTokens')}
            </Button>
          }
        >
          {t('services.generateVideo.insufficientTokens')}
        </Alert>
      )}
    </div>
  );
};
